const css = `.UZRYba__content{overflow-wrap:break-word;word-wrap:break-word;white-space:normal;text-align:left;line-height:initial;overflow:auto}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"content":"UZRYba__content"};
